export const GET_KINDERGARTEN_DIETARY_OPTIONS = 'GET_KINDERGARTEN_DIETARY_OPTIONS';
export const SET_KINDERGARTEN_DIETARY_OPTIONS = 'SET_KINDERGARTEN_DIETARY_OPTIONS';
export const CREATE_KINDERGARTEN_DIETARY_OPTION = 'CREATE_KINDERGARTEN_DIETARY_OPTION';
export const ADD_KINDERGARTEN_DIETARY_OPTION = 'ADD_KINDERGARTEN_DIETARY_OPTION';
export const DELETE_KINDERGARTEN_DIETARY_OPTION = 'DELETE_KINDERGARTEN_DIETARY_OPTION';
export const REMOVE_KINDERGARTEN_DIETARY_OPTION = 'REMOVE_KINDERGARTEN_DIETARY_OPTION';
